import { post } from './ApiService';
import { ServiceContainer } from './ServiceContainer/ServiceContainer';

import { NewsResponse } from '../Interface/Response/Interest/News';
import { FetchInterface } from '../Interface/News/NewsInterface';

export const postNewsData = <T>(uri: string, body: string): Promise<T> => {
    const { storeGateway } = ServiceContainer;
    return post<T>(uri, body, storeGateway.getState().auth.token);
};

export const getInterestNews: FetchInterface = (
    labels: string[],
    dateFrom: string,
    dateTo: string,
    page: number
): Promise<NewsResponse> => {
    const dateRange = { from: dateFrom, to: dateTo };
    return postNewsData<NewsResponse>('v1/news/list', JSON.stringify({ labels, dateRange, page }));
};

export const getPropertiesNews: FetchInterface = (
    labels: string[],
    dateFrom: string,
    dateTo: string,
    page: number
): Promise<NewsResponse> => {
    const dateRange = { from: dateFrom, to: dateTo };
    return postNewsData<NewsResponse>(
        'v1/news/product-properties/list',
        JSON.stringify({ labels, dateRange, page })
    );
};
